import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { MerchSizes } from './constants';
import { buildMerchStoreConfig } from '../storeAliasHelper';
import { data_STAGING } from './STAGING';

export const CyborgClassicLongSleeveProduct = {
  title: 'Cyborg Classic Long Sleeve T-shirt',
  description: '100% organic Supima cotton. Made carbon neutral.',
  imgSrc:
    'web_v2/all-products/merch/new/cyborg-classic-fsleeve-tee-black.png/w_1920',
  tag: 'popular',
  shopifyProductName: 'Cyborg Classic Long Sleeve T-shirt',
  availableSizes: [
    MerchSizes.XS,
    MerchSizes.S,
    MerchSizes.M,
    MerchSizes.L,
    MerchSizes.XL,
    MerchSizes.XXL,
  ],
};

export const CyborgClassicLongSleeveShopifyMap: Record<
  ShopifyStore,
  {
    price: number;
    sizes: Record<MerchSizes, { variantId: string; checkoutUrl: string }>;
  }
> =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? buildMerchStoreConfig<MerchSizes>({
        [ShopifyStore.AE]: {
          price: 130,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/44691314409714',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691314409714:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/44691314442482',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691314442482:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/44691314475250',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691314475250:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/44691314508018',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691314508018:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/44691314540786',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691314540786:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/44691314573554',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691314573554:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.US]: {
          price: 35,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/40200409907296',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200409907296:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40200409940064',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200409940064:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40200409972832',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200409972832:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40200410005600',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200410005600:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40200410038368',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200410038368:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40200410071136',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200410071136:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.ROW]: {
          price: 35,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/40718613643324',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718613643324:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40718613676092',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718613676092:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40718613708860',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718613708860:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40718613741628',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718613741628:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40718613774396',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718613774396:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40718613807164',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718613807164:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.IN]: {
          price: 1899,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/40737852260422',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737852260422:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40737852293190',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737852293190:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40737852325958',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737852325958:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40737852358726',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737852358726:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40737852391494',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737852391494:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40737852424262',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737852424262:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.EU]: {
          price: 32,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/49202717753662',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202717753662:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/49202717786430',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202717786430:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/49202717819198',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202717819198:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/49202717851966',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202717851966:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/49202717884734',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202717884734:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/49202717917502',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202717917502:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.GB]: {
          price: 28,
        },
        [ShopifyStore.AU]: {
          price: 52,
        },
        [ShopifyStore.CA]: {
          price: 48,
        },
        [ShopifyStore.MX]: {
          price: 749,
        },
        [ShopifyStore.SA]: {
          price: 216,
        },
        [ShopifyStore.ZA]: {
          price: 699,
        },
        [ShopifyStore.JP]: {
          price: 5480,
        },
      })
    : data_STAGING;
